
  // Function to get cart products and update the ContactForm-body textarea
  function updateContactForm() {
    // Replace 'YOUR_SHOPIFY_STORE_URL' with the actual Shopify store URL
    var apiUrl = 'https://s0d1gm-xh.myshopify.com/cart'; // Replace with your Shopify store URL

    // Use Fetch API to get the cart data
    fetch(apiUrl + '.js')
      .then(response => response.json())
      .then(data => {
        // Ensure items array is present and not empty
        var items = Array.isArray(data.items) ? data.items : [];

        // Extract product information from the cart data
        var products = items.map(item => {
          return `${item.title} - Quantity: ${item.quantity}`;
        });

        // Insert the product information into the ContactForm-body textarea
        document.getElementById('ContactForm-body').value = products.join('\n');
      })
      .catch(error => {
        console.error('Error fetching cart data:', error);
      });
  }

  // Call the function to update the textarea
  updateContactForm();

  var customCheckoutURL = '/pages/contact';
  // Add event listener to the checkout button
  document.getElementById('checkout').addEventListener('click', function (event) {
    event.preventDefault(); // Prevent the default form submission
    window.location.href = customCheckoutURL; // Redirect to the custom checkout URL
  });

function clearCart() {
    var xhrClearCart = new XMLHttpRequest();
    xhrClearCart.open('POST', '/cart/clear.js', true);
    xhrClearCart.send();  
}

